import {useMutation, useQueryClient} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api, {CreateLayout} from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useCreateLayout() {
  const {enqueueSnackbar} = useSnackbar()
  const client = useQueryClient()

  const mutation = useMutation({
    mutationFn: async (body: CreateLayout) => {
      return await api.layout.create(body)
    },
    onSuccess: async () => {
      await client.invalidateQueries({queryKey: [QueryKeyEnum.LAYOUTS]})
      enqueueSnackbar('Layout criado com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não foi possível criar o layout no momento')
    },
  })
  return mutation
}
